import { render, staticRenderFns } from "./ProductSpecsElementForm.vue?vue&type=template&id=60c3667b"
import script from "./ProductSpecsElementForm.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c3667b')) {
      api.createRecord('60c3667b', component.options)
    } else {
      api.reload('60c3667b', component.options)
    }
    module.hot.accept("./ProductSpecsElementForm.vue?vue&type=template&id=60c3667b", function () {
      api.rerender('60c3667b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecsElement/ProductSpecsElementForm.vue"
export default component.exports